import { flow, types } from 'mobx-state-tree';
import { BuildsApiGateway } from '../../apiGateway/BuildsApiGateway';
import { BuildDto } from '../../apiGateway/Dtos/BuildDto';
import { MapDtoToBuildModel } from './BuildMap';
import { Build } from './Builld';
import { getDeviceOS } from '../../utils';

export const BuildStore = types.model(
  'BuildStore',
  {
    apiGateway: BuildsApiGateway,
    build: types.maybeNull(Build),
    isLoading: false
  })
  .actions(self => ({

    getBuild: flow(function* (projectId: string, buildId: string) {

      self.isLoading = true;

      try {
        const buildDto: BuildDto = yield self.apiGateway.getBuild(projectId, buildId);
        self.build = Build.create(MapDtoToBuildModel(buildDto));
        self.isLoading = false;

        const os = getDeviceOS();

        if (os === 'android') {
          if (self.build.androidArtefacts().length > 0)
            return self.build;
          else
            throw new Error(`No Android artefacts found for build ${buildId}`);
        }

        if (os === 'ios') {
          if (self.build.iosArtefacts().length > 0)
            return self.build;
          else
            throw new Error(`No iOS artefacts found for build ${buildId}`);
        }

        return self.build;

      } catch (e: any) {
        throw new Error(e.message ? e.message : `No build found with Id ${buildId}`);
      }
    }),

    makeBuildPublic: flow(function* (projectId: string, buildId: string) {

      self.isLoading = true;

      try {
        yield self.apiGateway.makeBuildPublic(projectId, buildId);
        self.isLoading = false;

      } catch (e: any) {
        throw new Error(`Failed to make build (${buildId}) public: ${e}`);
      }
    }),

    makeBuildPrivate: flow(function* (projectId: string, buildId: string) {
      self.isLoading = true;

      try {
        yield self.apiGateway.makeBuildPrivate(projectId, buildId);

        self.isLoading = false;

      } catch (e: any) {
        throw new Error(`Failed to make build (${buildId}) private: ${e}`);
      }
    }),

    shareBuild: flow(function* (projectId: string, buildId: string, emailAddresses: string[]) {
      self.isLoading = true;

      try {
        yield self.apiGateway.shareBuild(projectId, buildId, emailAddresses);

        self.isLoading = false;

      } catch (e: any) {
        throw new Error(`Failed to share build (${buildId}) with ${emailAddresses}: ${e}`);
      }
    }),

    addReleaseNotesToBuild: flow(function* (projectId: string, buildId: string, releaseNotes: string) {
      self.isLoading = true;

      try {
        yield self.apiGateway.addReleaseNotesToBuild(projectId, buildId, releaseNotes);

        self.isLoading = false;

      } catch (e: any) {
        throw new Error(`Failed to add release notes to build (${buildId}): ${e}`);
      }
    }),

    clearReleaseNotesFromBuild: flow(function* (projectId: string, buildId: string) {
      self.isLoading = true;

      try {
        yield self.apiGateway.clearReleaseNotesFromBuild(projectId, buildId);

        self.isLoading = false;

      } catch (e: any) {
        throw new Error(`Failed to clear release notes to build (${buildId}): ${e}`);
      }
    })
  }));


// export interface IBuildStore extends Instance<typeof BuildStore> {
// }
